/**
 * The background tints a client file (Kundenakt) can be shown with, in the order the tint index
 * addresses them. The index comes from the backend (`ClientDetailResponse.tintIndex`), which derives
 * it from the client's master data, so the same client always lands on the same colour.
 *
 * Values are oklch: at a shared chroma the eight hues read as equally strong, which plain sRGB
 * cannot do. Do not pass them through MUI's `alpha()` or `lighten()` — those cannot parse oklch.
 */
export const CLIENT_FILE_TINTS: readonly string[] = [
  "oklch(0.93 0.09 150)", // sage, #bdfac8
  "oklch(0.846 0.09 235)", // sky, #91d6ff
  "oklch(0.832 0.09 290)", // lavender, #c7beff
  "oklch(0.837 0.09 20)", // rose, #ffb2b1
  "oklch(0.893 0.09 75)", // sand, #ffd498
  "oklch(0.93 0.09 195)", // petrol, #9dfbfa
  "oklch(0.895 0.09 330)", // mauve, #ffc7f9
  "oklch(0.93 0.09 115)", // olive, #e5f0aa
];

/**
 * The tint for a client file, or `undefined` when the index does not address one — which renders
 * the client file the way it looks with colour coding switched off.
 */
export function getClientFileTint(tintIndex: number): string | undefined {
  if (!Number.isInteger(tintIndex) || tintIndex < 0 || tintIndex >= CLIENT_FILE_TINTS.length) {
    return undefined;
  }

  return CLIENT_FILE_TINTS[tintIndex];
}
